import React, {useState} from "react";

interface DetailsStateProps {
    open: boolean;
}

export interface DetailsStateReturn extends DetailsStateProps {
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 * State hook providing a single place to control the `open` attribute.
 * It is used internally by the `Details` component itself while still
 * being completely controllable from any parent component.
 */
export const useDetailsState = (
    props: DetailsStateProps
): DetailsStateReturn => {
    const [open, setOpen] = useState(props.open);

    return {
        open,
        setOpen
    };
};
